export default {
  async getAccounts ({commit}, payload) {

    const accounts = await window.axios.get('/accounts', {
      params: payload
    })
    commit('SET_ACCOUNTS', accounts.data.data || [])

    return accounts.data
  },

  async getAccountById ({commit}, {accountId}) {
    const response = await window.axios.get(`/accounts/${accountId}/owner`)
    if (!response.data.address) {
      response.data.address = {
        country: null,
        city: null,
        street: null
      }
    }

    commit('SET_ACCOUNT_DETAILS', response.data)
  },

  async updateAccount ({commit}, {accountId, body}) {
    const response = await window.axios(`/accounts/${accountId}`, {
      method: 'POST',
      data: body,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })

    commit('ACCOUNT_UPDATED', response.data)

    return response
  },

  async statistics (vuex, {accountId}) {
    return await window.axios.get(`/accounts/${accountId}/statistics`)
  },

  async deleteAccount ({commit}, account) {
    await window.axios.delete(`/accounts/delete/${account.id}`)

    commit('SET_DELETED_ACCOUNT', account)
  },

  async getPixelTrackingDetails ({commit}) {
    const response = await window.axios.get('/recommendations/get/pixel_tracking_details')

    commit('SET_PIXEL_TRACKING_DETAILS', response.data.payload)
  },

  async setTrackingDebugKey ({commit}, key) {
    commit('SET_TRACKING_DEBUG_KEY', key)
  }
}
